<script>
  import { userCanBookDemoStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
  import BookDemoWithAMButton from "./BookDemoWithAMButton.svelte";
  import RegisterInterestButton from "./RegisterInterestButton.svelte";

  let { license } = $props();
</script>

{#if $userCanBookDemoStore}
  <BookDemoWithAMButton kind="upgrade" {license} />
{:else}
  <RegisterInterestButton kind="upgrade" {license} />
{/if}
